module.exports = __webpack_public_path__ + "media/small_drum_room.47cb969b.wav";